import { Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { Link } from 'components/Link';

export type ArticlePreviewProps = {
  excerpt?: string;
  slug: string;
  title: string;
  published?: string;
};

export const ArticlePreview = ({
  title,
  excerpt,
  slug,
}: ArticlePreviewProps) => {
  return (
    <>
      <Flex
        mb={2}
        direction="column"
        width="100%"
        alignItems="flex-start"
        as="article"
      >
        <Heading as="h2" fontSize="2xl" textAlign="left" display="block">
          <Link
            href={`/articles/${slug}`}
            textDecoration="none"
            _hover={{ textDecoration: 'none' }}
          >
            {title}
          </Link>
        </Heading>
        {excerpt && (
          <Text
            as="p"
            marginTop="2"
            color={useColorModeValue('gray.700', 'gray.200')}
            fontSize="md"
            fontWeight="normal"
          >
            {excerpt}
          </Text>
        )}
      </Flex>
    </>
  );
};
